<script>
import {
  TYPE_OPTIONS,
  OPACITY_OPTIONS,
  WEIGHT_OPTIONS,
  COLOR_OPTIONS
} from './consts'

export default {
  name: 'CTypo',

  functional: true,

  props: {
    /**
     * Defines the font-family and font-size css values
     */
    type: {
      type: String,
      default: 'body-1',
      validator: (value) => TYPE_OPTIONS.includes(value)
    },

    /**
     * Defines the opacity, be aware that not all combinations with color
     * works. Check the $color-palletes rcss variable to check all valid combinations
     */
    opacity: {
      type: String,
      default: 'base',
      validator: (value) => OPACITY_OPTIONS.includes(value)
    },

    /**
     * Defines the font-style italic css property
     */
    italic: {
      type: Boolean,
    },

    /**
     * Defines the text-decoration line-through css property
     */
    strikethrough: {
      type: Boolean,
    },

    /**
     * Defines the text-transform uppercase css property
     */
    uppercase: {
      type: Boolean,
    },

    /**
     * Defines the font-weight css property
     */
    weight: {
      type: String,
      default: 'regular',
      validator: (value) => WEIGHT_OPTIONS.includes(value)
    },

    /**
     * Defines the color, be aware that not all combinations with opacity
     * works. Check the $color-palletes rcss variable to check all valid combinations
     */
    color: {
      type: String,
      default: 'neutral',
      validator: (value) => COLOR_OPTIONS.includes(value)
    },

    /**
     * If there is an emoji, it stays with its original color without opacity
     */
    isEmoji: Boolean,

    /**
     * Renders HTML string content. Use when content contains HTML tags.
     * When provided, takes precedence over slot content.
     */
    html: {
      type: String,
      default: null
    },
  },

  render (h, { props, slots, data }) {
    const staticClasses = data?.staticClass?.split(' ')
    const dynamicClasses = data?.class

    const classes = [
      'c-typo',
      `-type-${props.type}`,
      {
        '-italic': props.italic,
        '-strikethrough': props.strikethrough,
        '-uppercase': props.uppercase,
        '-emoji': props.isEmoji,
      },
      ...(staticClasses || []),
      dynamicClasses
    ]

    const style = {
      '--typo-color': `var(--color-${props.color}-${props.opacity})`,
      '--typo-weight': `var(--font-weight-${props.weight})`
    }

    return h(
      'span',
      {
        class: classes,
        style,
        directives: data.directives,
        domProps: props.html ? { innerHTML: props.html } : undefined,
      },
      props.html ? undefined : slots().default
    )
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
